import {
  GET_ALL_DEPARTMENT_FAIL,
  GET_ALL_DEPARTMENT_REQUEST,
  GET_ALL_DEPARTMENT_SUCCESS,
  GET_SINGLE_DEPARTMENT_FAIL,
  GET_SINGLE_DEPARTMENT_REQUEST,
  GET_SINGLE_DEPARTMENT_SUCCESS,
  ADD_DEPARTMENT_FAIL,
  ADD_DEPARTMENT_REQUEST,
  ADD_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_FAIL,
  UPDATE_DEPARTMENT_REQUEST,
  UPDATE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_REQUEST,
  DELETE_DEPARTMENT_FAIL,
  CLEAR_DEPARTMENT_RECORD,
} from "../constant/DepartmentConstant";
const initialState = {
  loading: false,
  action: "Department",
  result: [],
  singledata: [],
  message: "",
  error: "",
  success: false,
};

const DepartmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_DEPARTMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload.data.list,
        message: action.message,
      };
    case GET_ALL_DEPARTMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };
    case GET_SINGLE_DEPARTMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SINGLE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        singledata: action.payload.data,
        message: action.message,
      };
    case GET_SINGLE_DEPARTMENT_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false,
        message: action.message,
      };

    case ADD_DEPARTMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.filter((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.payload,
      };
    case ADD_DEPARTMENT_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    case UPDATE_DEPARTMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.map((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.message,
      };
    case UPDATE_DEPARTMENT_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        message: action.message,
        error: action.error,
      };

    case DELETE_DEPARTMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        result: state.result.filter((item) => item.id !== action.payload.id),
        message: action.message,
      };
    case DELETE_DEPARTMENT_FAIL:
      return {
        ...state,
        loading: true,
        error: action.error,
        message: action.message,
      };
    case CLEAR_DEPARTMENT_RECORD:
      return {
        ...state,
        result: [],
        singledata: [],
        message: action.message,
      };

    default:
      return state;
  }
};

export default DepartmentReducer;
